/* RESPONSIBLE TEAM: team-inbox-experience */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    topics: {
      serialize: false,
      deserialize: 'records',
    },
    subscriptions: {
      serialize: false,
      deserialize: 'records',
    },
  },
});
